var _style, _path, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;enable-background:new    ;}\r\n\t.st1{fill:#343433;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37430",
    className: "st0",
    d: "M11.3,43.5H6.5c-1.1,0-1.9-0.9-1.9-1.9V23.2c0-1.1,0.9-1.9,1.9-1.9h4.8c1.1,0,1.9,0.9,1.9,1.9 v18.4C13.3,42.7,12.4,43.5,11.3,43.5C11.3,43.5,11.3,43.5,11.3,43.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,26.4c0-2.1-1.7-3.8-3.8-3.8H29.4c0.9-2.4,2.5-7.7,0.2-11.1c-0.2-0.3-0.4-0.5-0.5-0.7 c-0.6-0.8-1.5-1.2-2.5-1.3c-1.9-0.2-3.6,1.3-3.8,3.2L22.5,16v0c0,0.4-0.2,0.9-0.4,1.2l0,0c-0.9,1.4-1.8,2.8-2.9,4.1 c-0.5,0.6-1.3,0.9-2,0.9h-3.1c-0.4-1.2-1.5-2-2.8-2H6.5c-1.6,0-2.9,1.3-2.9,2.9v18.4c0,1.6,1.3,2.9,2.9,2.9h4.8 c1.6,0,2.9-1.3,2.9-2.9v-0.1h2.9C20,44.4,23.8,46,27.8,46H35h0c1.8,0,3.3-1.5,3.3-3.3c0-0.5-0.1-1-0.3-1.4c1.6-0.4,2.9-1.8,2.9-3.6 c0-0.8-0.2-1.6-0.7-2.2c1.3-0.6,2.2-1.9,2.2-3.4c0-0.7-0.2-1.4-0.6-2C43.3,29.5,44.4,28.1,44.4,26.4z M12.3,41.6 C12.3,41.6,12.3,41.6,12.3,41.6c0,0.5-0.4,0.9-0.9,0.9H6.5c-0.5,0-0.9-0.4-0.9-0.9V23.2c0-0.5,0.4-0.9,0.9-0.9h4.8 c0.5,0,0.9,0.4,0.9,0.9V41.6z M40.6,28.2h-2h-0.4h-0.8v2h0.8h0.4c1,0,1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8h-1.4h-1h-0.6v2h0.6h1 c0.9,0,1.7,0.8,1.7,1.7c0,1-0.8,1.8-1.7,1.8H35h-0.1h-0.7v2h0.7H35c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3h-7.2 c-3.6,0-7-1.5-9.5-4.2c-0.2-0.2-0.5-0.3-0.7-0.3h-3.3V24.2h2.9c1.3,0,2.6-0.6,3.5-1.5c1.2-1.4,2.2-2.8,3.2-4.4 c0.4-0.6,0.6-1.4,0.7-2.1l0.3-3.3c0-0.6,0.5-1.1,1.1-1.3c0.6-0.2,1.2,0,1.6,0.5c0.1,0.2,0.3,0.4,0.5,0.6c1.2,1.8,0.9,4.5,0.5,6.4 c-0.3,1.2-0.7,2.4-1.2,3.6h-2v2h15.4c1,0,1.8,0.8,1.8,1.8S41.6,28.2,40.6,28.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 12.6,
    className: "st1",
    width: 4.3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6,
    y: 12.6,
    className: "st1",
    width: 4.3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 1,
    className: "st1",
    width: 2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.9,
    y: 4.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1.1571 15.1886)",
    className: "st1",
    width: 2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 5.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 5.4856 25.6379)",
    className: "st1",
    width: 4.3,
    height: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_789",
    className: "st1",
    cx: 8.9,
    cy: 38.5,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeNormal);
export default __webpack_public_path__ + "static/media/like-normal.e7591cc9e14e87ff704abd72679a8f8b.svg";
export { ForwardRef as ReactComponent };